import axios from 'axios';
import { createApp } from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';;
import useAuth from '@/hooks/auth';
import App from './App.vue';
import router from './router';
import quasarUserOptions from './quasar-user-options';

const { login } = useAuth();

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      login();
    }
    return Promise.reject(error);
  },
);

const app = createApp(App).use(Quasar, quasarUserOptions);

app.config.globalProperties.$filters = {
  yesNo(val) { return val ? 'Yes' : 'No'; },
  receivedPending(val) { return val ? 'Received' : 'Pending'; },
};

app.use(router).mount('#app');
